module.exports = __webpack_public_path__ + "img/v55.c2abd769.jpg";